module.exports = {
	header : {
		title : 'Registrant Area',
	},
	footer : {
		faq : 'FAQ',
		tnp : 'Terms & Policy',
		contact : 'Contact Us',
	},

	//SignIn
	signin : {
		head : 'Registrant Portal',
		alert : {
			sent : {
				label : 'Please check your e-mail inbox',
				desc : 'A unique link to reset your password has been sent to your registered e-mail.',
			},
			complete : {
				label : 'You’ve successfully set up an account',
				desc : 'Please sign in using your registered e-mail address and password to continue.',
			},
			reset : {
				label : 'You’ve successfully reset your password',
				desc : 'Please sign in using your new password to continue.',
			},
		},
		form : {
			email : 'E-mail Address',
			emailmsg : 'Sign in failed, please check your e-mail address.',
			pwd : 'Password',
			pwdmsg : 'Reset my password',
			resetbtn : 'Forgot password?',
		},
		agree : '<p class="legalnotice">By continuing, you agree to our <a href="https://borobudurmarathon.com/terms-policy" target="_blank">Terms of Use and Privacy Policy</a>.</p>',
		btn : 'Sign In',
		reg : 'Register',
		errnet : 'Network disconnected, please check your internet connection.',
		reset : {
			head : 'Create your new password',
			place1 : 'Enter new password',
			place2 : 'Repeat new password',
			errmsg1 : 'One lowercase letter required',
			errmsg2 : 'One uppercase letter required',
			errmsg3 : '8 characters minimum',
			errmsg4 : 'One number required',
			errmsg5 : 'Password does not match',
			btn : 'Confirm',
		},
	},

	//SignUp
	signup : {
		head : 'Account Creation',
		otp : {
			label : 'We’ve sent One Time Password to your e-mail address.',
			desc : 'Please insert it here or click the verification link on the message.',
			form : 'One Time Password',
			btn : 'Verify',
			later : 'Verify Later',
		},
		form : {
			email : 'E-mail Address',
			check : 'Check',
			used : '<h6>This e-mail address has been registered before.</h6>\
			<p>If you’ve participated in <strong>Borobudur Marathon 2019</strong>, <a href="/signin/resetPasswordRequest">reset your password</a> to sign in to your account.</p>\
			<div class="separator"><p class="center-line"><span>or</span></p></div>\
			<p style="margin-bottom:0">If you’ve not verified this e-mail address,</p>',
			invitation: {
				head : '<h5>How\'d you like to set up your new account?</h5>',
				reuse : 'I\'d like to use my personal data from 2019 registration',
				new : 'I\'d like to register new account',
				sent : {
					label : 'Please check your e-mail inbox',
					desc : 'A unique link to create new password has been sent to your e-mail.',
				},
			},
			separator: '<div class="separator"><p class="center-line"><span>or</span></p></div>',
			resendCode : 'resend the verification code',
			name : 'Full Name',
			named : 'as stated on your identity card',
			gender : 'Gender',
			pwd : 'Password',
			pwdplace : 'Enter password',
			rpwdplace : 'Repeat password',
			errmsg1 : 'One lowercase letter required',
			errmsg2 : 'One uppercase letter required',
			errmsg3 : '8 characters minimum',
			errmsg4 : 'One number required',
			errmsg5 : 'Password does not match',
			},
		agree : '<p class="legalnotice">By continuing, you agree to our <a href="https://borobudurmarathon.com/terms-policy" target="_blank">Terms of Use and Privacy Policy</a>.</p>',
		btn : 'Register',
		in : 'Sign In',
	},

	//HomeView
	user : {
		linktoprofile : 'View Personal Data',
		trivia : 'Did you know?',
	},
	status : {
		idle : {
			head : 'Borobudur is calling you!',
			label : 'Register yourself right now.',
			desc : 'Choose your desired registration channel to run in Borobudur Marathon 2020',
			btn : 'Continue',
		},
		wait : {
			head : 'One more step to run in Borobudur.',
			label : 'Waiting for ballot drawing result',
			desc : 'You have successfully casted a ballot for Borobudur Marathon 2020. The drawing result will be announced on 9-12 June 2020.',
		},
		FRQwait : {
			head : 'One more step to run in Borobudur.',
			label : 'Waiting for announcement',
			desc : 'You have successfully registered for Borobudur Marathon 2020 fast runner qualification. The filtering result will be announced on 7-14 May 2020.',
		},
		switched : {
			head : 'One more step to run in Borobudur.',
			label : 'Switched to ballot drawing',
			desc : 'Your fast runner qualifying registration has been switched to ballot. The drawing result will be announced on 9-12 June 2020.',
		},
		drawing : {
			head : 'One more step to run in Borobudur.',
			label : 'Drawing in progress',
			desc : 'Borobudur Marathon 2020 ballot drawing is in progress, your drawing result will be announced before 12 June 2020.',
		},
		pay : {
			head : 'One more step to run in Borobudur.',
			label : 'Waiting for payment',
			desc : 'Your registration is accepted. Please ensure to make the payment before {timelimit} to secure your slot.',
			btn : 'Continue to payment section',
			jbtn : 'Choose jersey size',
		},
		transferring : {
			head : 'Borobudur is waiting for you.',
			label : 'Bib transfer in progress',
			desc : 'Your participation slot is being transferred. See you in the next opportunity.',
		},
		success : {
			head : 'Borobudur is waiting for you.',
			label : 'Participation slot confirmed',
			desc : 'Congratulations, you are officially a participant of Borobudur Marathon 2020. Further information related to the race preparation needs will be available on the section below.',
		},
		BJsuccess : {
			head : 'Borobudur is waiting for you.',
			label : 'Participation slot confirmed',
			desc : 'Congratulations, you’ve successfully registered for Borobudur Marathon 2020 using Bank Jateng program.',
		},
		unlucky : {
			head : 'There’s another way to run.',
			label : 'Ballot unsuccessful',
			desc : 'Your ballot is not selected for this year’s race. Sign up through another registration channel to continue your participation in Borobudur Marathon 2020.',
		},
		unpaid : {
			head : 'There’s another way to run.',
			label : 'Participation slot canceled',
			desc : 'Your slot has been canceled because no payment is completed within the time limit. Sign up through another registration channel to continue your participation in Borobudur Marathon 2020.',
		},
		transferred : {
			head : 'Borobudur is waiting for you.',
			label : 'Participation slot has been transferred',
			desc : 'Your participation slot has been transferred successfully. See you in the next opportunity.',
		},
		closed : {
			head : 'Count yourself in for next year.',
			label : 'The registration period for 2020 has been closed',
			desc : 'Otherwise, you still can join the excitement of Borobudur Marathon 2020 through Friendship Run. Register now on the section below.',
		},
	},
	regData : {
		category : {
			race : 'Race Category',
			code : 'Registration Code',
		},
		details : {
			head : 'Race Details',
			corral : 'Target Finish Time',
			bib : 'Name on Bib',
			jersey : 'Jersey Size',
			community : 'Running Community',
		},
		frq : {
			head : 'Fast Runner Qualifying Data',
			qrace: 'Qualifying Race Name',
			qcategory : 'Qualifying Race Category',
			qtime : 'Qualifying Race Finish Time',
		},
		emergency : {
			head : 'Emergency & Medical Details',
			name : 'Emergency Contact Name',
			number : 'Emergency Contact Number',
			medic : 'Medical Condition',
		},
	},
	friendship : {
		card : {
			head : 'Friendship Run',
			desc : 'Friendship Run is for everyone that wants to enjoy the beautiful nature, the richness of the culture and the culinary delicacy of Magelang.',
			btn : 'Join Now',
		},
		modal : {
			head : 'Friendship Run Registration',
			desc : 'Presented for everyone that wants to enjoy the beautiful nature, the richness of the culture and the culinary delicacy of Magelang. It doesn’t matter if you take a relaxing walk or light jog, let’s register now to have fun with family and friends at Friendship Run!',
			cta : 'Learn More',
			icon1h : 'Flag Off',
			icon1d : 'Saturday, 14 November 2020<br/>06.00 WIB (GMT+7)',
			icon2h : 'Venue',
			icon2d : 'Pawon Temple<br/>Magelang, Central Java, Indonesia',
			icon3h : 'Price',
			icon3d : 'IDR 125.000<br/>per person',
			msg : 'No need to enter any registration form as you’ve already registered for a Borobudur Marathon account. Simply click the join button below and proceed the payment to count yourself in the Friendship Run.',
			btn : 'Join Friendship Run',
		},
		status : {
			pay : {
				label : 'Waiting for payment',
				desc : 'Please ensure to make the payment before <strong>{{transactionData.data.trnsExpiredTime | moment("D MMMM YYYY HH:mm")}} WIB (GMT+7)</strong> to complete your Friendship Run registration.',
				btn : 'Pay Now',
			},
			unpaid : {
				label : 'Your registration has been canceled',
				desc : 'Your registration has been canceled due to no payment is completed within the time limit.',
				btn : 'Repurchase',
			},
			success : {
				label : 'Ready to run',
				desc : 'Don’t forget to enjoy the beautiful nature, the richness of the culture and the culinary delicacy of Magelang!',
			},
		},
		data : {
			code : 'Reg. Code',
			bib : 'Bib Number',
			btn : 'Learn More',
		},
	},
	shuttle : {
		card : {
			head : 'Shuttle Bus',
			desc : 'Borobudur Marathon provides a shuttle bus service for every participant who stay in Yogyakarta or Magelang to the location of the event on race day.',
			btn : 'Buy Ticket',
		},
		modal : {
			head : 'Shuttle Bus',
			lpoint : 'Departure & Return Point',
			p1 : '<h5>Plaza Ambarrukmo Yogyakarta</h5><p>Jalan Laksda Adisucipto No. 80, Sleman, Yogyakarta 56172</p>\
			<p>First Departure: 02.00 WIB<br>Last Departure: 02.30 WIB</p>\
			<a rel="noopener" target="_blank" href="https://goo.gl/maps/b4TZD8ApPGuzWDKn7" class="btn btn-outline-secondary btn-sm rounded-pill">Directions <svg width="1em" height="1em" viewBox="0 0 20 20" focusable="false" role="img" alt="icon" xmlns="http://www.w3.org/2000/svg" fill="currentColor" class="bi-arrow-right b-icon bi"><g><path fill-rule="evenodd" d="M12.146 6.646a.5.5 0 01.708 0l3 3a.5.5 0 010 .708l-3 3a.5.5 0 01-.708-.708L14.793 10l-2.647-2.646a.5.5 0 010-.708z" clip-rule="evenodd"></path><path fill-rule="evenodd" d="M4 10a.5.5 0 01.5-.5H15a.5.5 0 010 1H4.5A.5.5 0 014 10z" clip-rule="evenodd"></path></g></svg></a>',
			p2 : '<h5>Abu Bakar Ali Parking Area</h5><p>Jalan Abu Bakar Ali No. 1, Danurejan, Yogyakarta 55213</p>\
			<p>First Departure: 02.00 WIB<br>Last Departure: 02.30 WIB</p>\
			<a rel="noopener" target="_blank" href="https://goo.gl/maps/SnNZs3MiBtVoeSJu8" class="btn btn-outline-secondary btn-sm rounded-pill">Directions <svg width="1em" height="1em" viewBox="0 0 20 20" focusable="false" role="img" alt="icon" xmlns="http://www.w3.org/2000/svg" fill="currentColor" class="bi-arrow-right b-icon bi"><g><path fill-rule="evenodd" d="M12.146 6.646a.5.5 0 01.708 0l3 3a.5.5 0 010 .708l-3 3a.5.5 0 01-.708-.708L14.793 10l-2.647-2.646a.5.5 0 010-.708z" clip-rule="evenodd"></path><path fill-rule="evenodd" d="M4 10a.5.5 0 01.5-.5H15a.5.5 0 010 1H4.5A.5.5 0 014 10z" clip-rule="evenodd"></path></g></svg></a>',
			p3 : '<h5>Televisi Republik Indonesia Yogyakarta</h5><p>Jalan Magelang No. 74, Sleman, Yogyakarta 55284</p>\
			<p>First Departure: 02.00 WIB<br>Last Departure: 02.30 WIB</p>\
			<a rel="noopener" target="_blank" href="https://goo.gl/maps/ccxsFcNiBQzujDwT7" class="btn btn-outline-secondary btn-sm rounded-pill">Directions <svg width="1em" height="1em" viewBox="0 0 20 20" focusable="false" role="img" alt="icon" xmlns="http://www.w3.org/2000/svg" fill="currentColor" class="bi-arrow-right b-icon bi"><g><path fill-rule="evenodd" d="M12.146 6.646a.5.5 0 01.708 0l3 3a.5.5 0 010 .708l-3 3a.5.5 0 01-.708-.708L14.793 10l-2.647-2.646a.5.5 0 010-.708z" clip-rule="evenodd"></path><path fill-rule="evenodd" d="M4 10a.5.5 0 01.5-.5H15a.5.5 0 010 1H4.5A.5.5 0 014 10z" clip-rule="evenodd"></path></g></svg></a>',
			p4 : '<h5>Armada Town Square Magelang</h5><p>Jalan Mayjen Bambang Soegeng No. 1, Magelang, Central Java 56172</p>\
			<p>First Departure: 03.00 WIB<br>Last Departure: 03.30 WIB</p>\
			<a rel="noopener" target="_blank" href="https://goo.gl/maps/5wFj2zbAgVZhtVhUA" class="btn btn-outline-secondary btn-sm rounded-pill">Directions <svg width="1em" height="1em" viewBox="0 0 20 20" focusable="false" role="img" alt="icon" xmlns="http://www.w3.org/2000/svg" fill="currentColor" class="bi-arrow-right b-icon bi"><g><path fill-rule="evenodd" d="M12.146 6.646a.5.5 0 01.708 0l3 3a.5.5 0 010 .708l-3 3a.5.5 0 01-.708-.708L14.793 10l-2.647-2.646a.5.5 0 010-.708z" clip-rule="evenodd"></path><path fill-rule="evenodd" d="M4 10a.5.5 0 01.5-.5H15a.5.5 0 010 1H4.5A.5.5 0 014 10z" clip-rule="evenodd"></path></g></svg></a>',
			lform : 'Ticket Registration',
			fpoint : 'Departure & Return Point',
			fpointdesc : 'Choose departure and return point to and from Race Central',
			freturn : 'Return Time',
			freturndesc : 'Choose return time schedule from Race Central to return point',
			fbtn : 'Buy Ticket',
		},
		status : {
			pay : {
				label : 'Waiting for payment',
				desc : 'Please ensure to make the payment before <strong>{{transactionData.data.trnsExpiredTime | moment("D MMMM YYYY HH:mm")}} WIB (GMT+7)</strong> to complete your shuttle bus ticket.',
				btn : 'Pay Now',
			},
			unpaid : {
				label : 'Your ticket has been canceled',
				desc : 'Your ticket has been canceled due to no payment is completed within the time limit.',
				btn : 'Repurchase',
			},
			success : {
				label : 'Your ticket is ready',
				desc : 'Here is the summary of your shuttle bus ticket. See you on the race day!',
			},
		},
		data : {
			code : 'Ticket Code',
			point : 'Departure & Return Point',
			dep : 'Departure Time',
			ret : 'Return Time',
		},
	},
	bib : {
		card : {
			head : 'Bib Transfer',
			desc : 'Bib transfer service is provided for registrants who wants to transfer the ownership of Borobudur Marathon participation slot.',
			btn : 'Transfer My Bib',
		},
		modal : {
			head : 'Bib Transfer',
			date : '21 September - 5 October 2020',
			step : '<div class="col"><div class="point"><h1>1</h1><p align="center">\
			Perform bib transfer by registering the recipient full name and valid e-mail address.\
			</p></div></div><div class="col"><div class="point"><h1>2</h1><p align="center">\
			Recipient will receive an invitation link in their e-mail inbox to start the registration for participant details.\
			</p></div></div><div class="col"><div class="point"><h1>3</h1><p align="center">\
			After the recipient made the payment for administration fee, your bib has been successfully transfered.</p></div></div>',
			ltnc : 'Terms & Conditions',
			tnc : '<ol>\
				<li>Bib transfer only applies to Participants who registered through Ballot Registration. Participants with Fast Runner Qualifying, Travel Agent Program, Bank Jateng Program and other programs from Borobudur Marathon, including those who obtain invitation and free slot from Borobudur Marathon are not allowed to transfer the bib number.</li>\
				<li>Bib number is the Participant official identification during the event and must be worn while the Participant is on the run course.</li>\
				<li>Official bib transfer can only be done through the registrant area of Borobudur Marathon during the Bib Transfer Period (as defined below).</li>\
				<li>Bib transfer can only be done during the Bib Transfer Period, from 21 September until 5 October 2020. Bib transfer request which exceeds the Bib Transfer Period will not be entertained.</li>\
				<li>The bib transfer process is a process to transfer the bib number of Transferor (as defined below) to the Transferee (as defined below). As such, the bib transfer causes the replacement of Transferor by the Transferee as a Participant in the same distance category as previously registered by the Transferor. The parties in the bib transfer process (Transferor and Transferee) cannot change the distance category. does not apply to change the distance category.</li>\
				<li>The bib transfer process must be initiated by the bib owner (“Transferor”) by opting to transfer his/her bib on the official website of Borobudur Marathon and entering the bib recipient’s email address.</li>\
				<li>Each Transferor can only perform one bib transfer process to one bib recipient’s e-mail address.</li>\
				<li>Please note that the bib number cannot be transferred to the individual who has already registered as the Participant. For the avoidance of doubt, Participant refers to those who have received the official entry confirmation email to the Borobudur Marathon 2019 throughout the Ballot Registration, Fast Runner Qualifying, Travel Agent Program, Bank Jateng Program  or other programs from Borobudur Marathon including those who obtain invitation and free slot from Borobudur Marathon.</li>\
				<li>Bib recipient (“Transferee”) will receive an email after the transfer procedure has been initiated by the Transferor. Transferee will obtain an e-mail from Borobudur Marathon containing the payment instruction of a transfer fee in the amount of IDR 100.000 (one hundred thousand rupiahs) through payment options available on the website.</li>\
				<li>The successful bib transfer process will make the Transferee into a Participant and the Transferor is no longer deemed as a Participant. Further, Transferee cannot perform the bib transfer process to anyone.</li>\
				<li>Transfer fee must only be paid during the Bib Transfer Period. Payment made exceeding the Bib Transfer Period will be annulled and the bib transfer process is cancelled. This kind of payment cannot be refunded.</li>\
				<li>If the bib transfer process is cancelled due to the late payment, the bib number will remain to the Transferor and the Transferor cannot perform any other bib transfer.</li>\
				</ol>',
			lform : 'Bib Transfer Request Form',
			fname : 'Recipient Full Name',
			fnamedesc : 'as stated on his/her identity card',
			femail : 'Recipient E-mail Address',
			femaildesc : 'We will send invitation link to this e-mail address',
			facceptance : 'By submitting the bib transfer request, therefore:\
			<ul><li>You agree to perform bib transfer.</li>\
			<li>You understand that the bib transfer can only be done once to the registered e-mail address above and cannot be edited or cancelled by you (transferor).</li>\
			<li>When the bib transfer is successful, You are no longer deemed as participant and cannot use the Borobudur Marathon 2020 slot which has been transferred to the transferee.</li></ul>',
			btn : 'Transfer My Bib',
		},
	},
	rpc : {
		card : {
			head : 'Race Pack Collection',
			desc : 'We recommend you to collect your own race pack and enjoy the variety of entertainment, booths, and authentic culinary in our signature race expo. Otherwise, you may delegate your race pack to your trusted representative.',
		},
		schedule : '<div class="groupLabel"><label>Schedule</label></div>\
			<table>\
				<tbody><tr>\
					<td class="heady">Thursday, 12 November</td>\
					<td>10.00 – 20.00 WIB</td>\
				</tr><tr>\
					<td class="heady">Friday, 13 November</td>\
					<td>10.00 – 20.00 WIB</td>\
				</tr><tr>\
					<td class="heady">Saturday, 14 November</td>\
					<td>10.00 – 18.00 WIB</td>\
				</tr></tbody>\
			</table>\
			<small><em>Western Indonesia Time (WIB) / GMT+7</em></small>\
		',
		venue : '<div class="groupLabel"><label>Venue</label></div>\
		<h5>Armada Town Square</h5>\
		<p>Jalan Mayjen Bambang Soegeng No. 1, Mertoyudan, Magelang, Central Java 56172</p>\
		<a rel="noopener" target="_blank" href="https://goo.gl/maps/eX5q5GTcTFrMDWF16" class="btn btn-outline-secondary btn-sm rounded-pill">Directions <svg width="1em" height="1em" viewBox="0 0 20 20" focusable="false" role="img" alt="icon" xmlns="http://www.w3.org/2000/svg" fill="currentColor" class="bi-arrow-right b-icon bi"><g><path fill-rule="evenodd" d="M12.146 6.646a.5.5 0 01.708 0l3 3a.5.5 0 010 .708l-3 3a.5.5 0 01-.708-.708L14.793 10l-2.647-2.646a.5.5 0 010-.708z" clip-rule="evenodd"></path><path fill-rule="evenodd" d="M4 10a.5.5 0 01.5-.5H15a.5.5 0 010 1H4.5A.5.5 0 014 10z" clip-rule="evenodd"></path></g></svg></a>',
		instructions : {
			label : 'Instructions',
			point : '<ol>\
			<li>Arrive at the race pack collection venue on the schedule mentioned above. Please note that there will be no race pack collection outside the official schedule and venue.</li>\
			<li>Show your registered identity card and the race pack collection QR code to our officer.</li>\
			<li>If you’re a participant that under 18 years old on the race day, you also need to submit the filled and signed <a href="https://assets.heartwork.co.id/bormar/2020-parental-consent-letter.pdf">parental consent letter</a>.</li>\
			<li>Receive your race pack and recheck to make sure your collected race pack is complete. Optionally, you can test the running tag tracker on your bib at the provided booth.</li>\
			<li>After you have collected your race pack, join and experience the variety of entertainment, booths, and authentic culinary in our signature race expo.</li>\
			</ol>',
			btn : 'Delegate my race pack collection'
		},
		delegation : {
			label : 'Race Pack Collection Delegation',
			statuslabel: 'Your race pack collection has been delegated',
			statusdesc : 'We’ve sent your race pack collection code to your representative below. Please contact your representative for more information about your race pack or tap the cancellation button if you wish to collect the race pack by your own.',
			rname : 'Representative Name',
			remail : 'Representative E-mail Address',
			rphone : 'Representative Phone Number',
			cancel : 'Cancel my race pack collection delegation',
		},
	},
	delrpc : {
		head : 'Race Pack Collection Delegation',
		lform : 'Letter of Authority',
		fname : 'Representative Full Name',
		fnamedesc : 'as stated on his/her identity card',
		femail : 'Representative E-mail Address',
		femaildesc : 'We will send your race pack collection code to this e-mail address',
		fphone : 'Representative Phone Number',
		facceptance : 'By submitting the letter of authority, I understand that:\
		<ol>\
			<li>Delegation of race pack collection is not bib transfer. Your representative person has no right whatsoever to run at Borobudur Marathon 2020 with your bib number.</li>\
			<li>After clicking confirmation button below, your right to collect race pack will be diverted to delegated person through issuance of new race pack collection code that will be sent to contact details above.</li>\
			<li>You can cancel delegation of race pack collection and collect your own race pack by clicking cancellation button on Registrant Area page.</li></ol>',
		btn : 'Submit',
	},
	raceday : {
		card : {
			head : 'Race Day',
			desc : 'Find out more details about entrance access, flag off time, event program, race central map, parking location and road closure on the race day.',
			btn : 'Learn More',
		},
	},
	
	//ProfileView
	profile : {
		status : {
			verified : 'Verified',
			verifying : 'Verifying',
			failed : 'Verification Failed',
			pending : 'Pending Verification',
		},
		pendingmsg : 'We need more time to verify the uploaded identity card with your personal data.<br/>Meanwhile, you may register for this year\'s race by continuing to dashboard.',
		updatebtn : 'Update Personal Data',
		reqbtn : 'Request Manual Verification',
		reqmsg : 'A request for manual verification has been sent and our team will directly verify the uploaded identity card with your personal data. Please recheck your verification status in 2x24 hours.',
		resetbtn : 'Reset Password',
		resetmsg : 'A unique link to reset your password has been sent to your registered e-mail.',
		dash : 'Back to Dashboard',
		card : {
			details : {
				head : 'Personal Details',
				nat : 'Nationality',
				gen : 'Gender',
				blo : 'Blood Type',
				dob : 'Date of Birth',
				pob : 'Place of Birth',
			},
			id : {
				head : 'Identity Card',
				typ : 'Identity Card Type',
				num : 'Identity Card Number',
				edu : 'Education',
				ocu : 'Occupation',
			},
			com : {
				head : 'Correspondence Details',
				ema : 'E-mail',
				pho : 'Phone Number',
				add : 'Address',
				cit : 'City/Regency',
				pro : 'Province',
				cou : 'Country',
			},
		},
	},
	validate : {
		alert : {
			reject : '<h6 class="text-center">Unable to verify your identity card</h6>\
			<p class="text-center">Please upload another valid identity card that match with your personal detail to continue.</p>'
		},
		phone : {
			head : 'Verify your phone number',
			desc : 'We’ll send One Time Password code via SMS to verify that your phone number is active and ready to receive our important notification.',
			label : 'Phone Number',
			send : 'Send OTP via SMS',
		},
		otp : {
			label : 'Enter OTP Code',
			place : '6 digits OTP Code',
			btnv : 'Verify',
			btnr : 'Resend OTP',
			later : 'Verify Later',
		},
		id : {
			head : 'Validate your identity card',
			labeltype : 'Identity Card Type',
			labelfile : 'Identity Card File',
			descfile : 'Upload scanned file of your identity card in JPG/JPEG/PNG file (max. 2 MB)',
			placefile : 'Choose a file or drop it here',
			dropfile : 'Drop a file here',
			labelselect : 'Selected file:',
			btn : 'Upload my identity card',
		},
		data : {
			head : 'One more step to complete your profile',
			idlabel : 'Identity Card Number',
			iddesc : 'as stated on your uploaded identity card',
			doblabel : 'Date of Birth',
			dobd : 'as stated on your uploaded identity card with minimum age requirement to register is 14 (fourteen) years from this year’s race day.',
			poblabel : 'Place of Birth',
			pobd : 'as stated on your uploaded identity card',
			blo : 'Blood Type',
			nat : 'Nationality',
			cou : 'Country',
			dom : 'Domicile Address',
			domdesc : 'Type and select name of city/regency in the provided selection list.',
			add : 'Address',
			cit : 'City/Regency',
			pro : 'Province',
			edu : 'Education',
			ocu : 'Occupation',
			inc : 'Monthly Income',
			accnews : 'I agree to receive news and exclusive offers for Borobudur Marathon registrant.',
			accok : 'I am sure that my personal data is accurate.',
			acctnp : 'I have read and agreed to the <a href="https://borobudurmarathon.com/terms-policy" target="_blank">terms of use and privacy policy</a> of Borobudur Marathon.',
			btn : 'Complete my profile',
		},
		select : {
			edu : {
				e1 : 'Elementary School',
				e2 : 'Junior High',
				e3 : 'Senior High',
				e4 : 'Diploma (D1/D2/D3)',
				e5 : 'Bachelor (S1)',
				e6 : 'Master (S2)',
				e7 : 'Doctorate (S3)',
			},
			ocu : {
				o1 : 'Business & Financial Worker',
				o2 : 'Civil Servant',
				o3 : 'Educational Worker',
				o4 : 'Entrepreneur',
				o5 : 'Freelance',
				o6 : 'Healthcare & Medicine Worker',
				o7 : 'Industrial Worker',
				o8 : 'Law Enforcement Worker',
				o9 : 'Private Employee',
				o10 : 'Professional',
				o11 : 'Student',
				o12 : 'Unemployed',
				o13 : 'Others',
			},
			inc : {
				i1 : '< IDR 1.000.000 or < US$ 100',
				i2 : 'IDR 1.000.000—5.000.000 or US$ 100—500',
				i3 : 'IDR 5.000.000—10.000.000 or US$ 500—1000',
				i4 : 'IDR 10.000.000—25.000.000 or US$ 1000—2500',
				i5 : 'IDR 25.000.000—50.000.000 or US$ 2500—5000',
				i6 : '> IDR 50.000.000 or > US$ 5000',
			},
		},
	},

	//RegistrationModal
	register : {
		ballot : 'Ballot Registration',
		frq : 'Fast Runner Qualifying',
		bankjateng : 'Bank Jateng Program',
		travel : 'Travel Agent Partners',

		form : {
			voucher : {
				label : 'Registration Details',
				code : 'Voucher Code',
				bjcode : 'Voucher code for registration of Bank Jateng Program. Please contact Bank Jateng Call Center 14066 for more information.',
				trcode : 'Voucher code for registration of Travel Agent Program. Please contact our travel agent partners for more information.',
			},
			detail : {
				label : 'Race Details',
				race : 'Race Category',
				raced : 'Choose your desired race category to run in Borobudur Marathon 2020',
				time : 'Target Finish Time',
				timed : 'Pick your target time in hours and minutes to finish the race',
				bib : 'Name on Running Bib',
				bibd : 'Name to display on your running bib (max. 16 characters)',
				jersey : 'Jersey Size',
				jerseyd : 'Choose the size of your running jersey',
				comm : 'Running Community',
				commd : 'Select from pre listed or type and press enter to add your own running community (optional)'
			},
			frq : {
				label : 'Qualification Details',
				qrace : 'Qualifying Race Name',
				qraced : 'Name of the race when you had the fastest official finish time within past 2 (two) years',
				qcat : 'Qualifying Race Category',
				qcatd : 'Race category in the qualifying race above',
				qtime : 'Qualifying Finish Time',
				qtimed : 'Official finish time on the qualifying race above',
				qfile : 'Qualifying Race Result Certificate File',
				qfiled : 'Upload the official race result certificate that includes your finish time in PDF/PNG/JPG file (max. 5 MB)',
				qurl : 'Qualifying Race Result Certificate URL',
				qurld : 'Attach the URL link to your race result certicifate from the official website of the qualifying race above. (optional)',
				qurlp : 'https://www.racetecresults.com/cert.aspx?uid=19723-66-4-123094'
			},
			emergency : {
				label : 'Emergency & Medical Details',
				name : 'Emergency Contact Name',
				named : 'Trusted person to be contacted in emergency situation',
				number : 'Emergency Contact Number',
				medic : 'Medical Condition',
				medicd : 'Describe your specific medical condition (optional)'
			},
			acceptance : 'By submitting the registration form, therefore:\
			<ul><li>You\'ve read and agreed to the <a href="https://borobudurmarathon.com/rules-regulations/" target="_blank">rules and regulations</a>.</li>\
			<li>You are sure that your registration data is accurate.</li>\
			<li>You understand that the registration can only be done once and you cannot change it after submission.</li>\
			</ul>',
			btn : 'Register',
			jbtn : 'Submit',
		},
	},

	//PaymentModal
	payment : {
		head : 'Payment Section',
		currency : 'IDR',
		code : 'Payment Code',
		limit : 'Payment Time Limit',
		voucher : 'Voucher Code',
		apply : 'Apply',

		pay : 'Choose Your Preferred Payment Method',
		paycc : '<img src="https://assets.heartwork.co.id/bormar/cc.png" style="width:200px"><br/>\
		<strong>Credit/Debit Card</strong><br/>\
		<span>Pay with Visa/MasterCard/JCB Credit or Debit Card</span>',
		paybt : '<img src="https://assets.heartwork.co.id/bormar/bt.png" style="width:100px"><br/>\
		<strong>Bank Transfer</strong><br/>\
		<span>Pay using Bank Jateng Virtual Account from ATM</span>',

		trans : 'Bank Transfer Instructions',
		va : 'Virtual Account Number',
		swift : 'Swift Code',
		atmbj : '<ol>\
		<li>From the menu, select "Transfer".</li>\
		<li>Enter virtual bank account number for payment: <strong>{{validVA.jtvaVANumber}}</strong>.</li>\
		<li>Enter the amount according to the <strong>total exact amount</strong> you have to pay. The amount that is not in accordance with the total bill will lead to a failure of transaction.</li>\
		<li>On the "Transfer Confirmation" page, make sure <strong>your name</strong> appears as the destination account name.</li>\
		<li>Select "True" to finalize the payment.</li>\
		<li>Keep the transfer receipt for future reference.</li></ol>',
		atmb : '<ol>\
		<li>From the menu, select "Other Transaction".</li>\
		<li>Select "Transfer".</li>\
		<li>Select "Other Bank".</li>\
		<li>Enter Bank Jateng code number "113" followed by 11 digit of virtual bank account number for payment. (<strong>113{{validVA.jtvaVANumber}}</strong>)</li>\
		<li>Make sure <strong>your name</strong> appears as the destination account name.</li>\
		<li>Enter the amount according to the <strong>total exact amount</strong> you have to pay. The amount that is not in accordance with the total bill will lead to a failure of transaction.</li>\
		<li>There is no need to enter the reference number, just proceed to select "True"</li>\
		<li>Select account type "Checking" or "Savings".</li>\
		<li>Keep the transfer receipt for future reference.</li></ol>',
		atmp : '<ol>\
		<li>From the menu, select "Transaction".</li>\
		<li>Select "Transfer Link/ATM Bersama/Prima".</li>\
		<li>Enter the amount according to the <strong>total exact amount</strong> you have to pay. The amount that is not in accordance with the total bill will lead to a failure of transaction.</li>\
		<li>Enter Bank Jateng code number: 113.</li>\
		<li>Enter virtual bank account number for payment: <strong>{{validVA.jtvaVANumber}}</strong>.</li>\
		<li>On the "Transfer Confirmation" page, make sure <strong>your name</strong> appears as the destination account name.</li>\
		<li>Select "True" to finalize the payment.</li>\
		<li>Keep the transfer receipt for future reference.</li></ol>',
	},
};


// WEBPACK FOOTER //
// src/languages/english.js